export default "__VITE_ASSET__DpzgjgRW__"